import { Global } from './Global'
import { MyApiKeys } from './my-api-keys'
import { Settings } from './Settings'
import { TimeLogging } from './TimeLogging'

export const settingsRoutes = [
  {
    path: '/settings',
    element: <Settings />,
    children: [
      {
        path: 'global',
        element: <Global />,
      },
      {
        path: 'time-logging',
        element: <TimeLogging />,
      },
      {
        path: 'my-api-keys',
        element: <MyApiKeys />,
      },
    ],
  },
]
